module.exports = __webpack_public_path__ + "img/10.4657d2c9.png";